// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-replay-tool {
  padding: 24px;
  max-width: 1100px;
  margin: 0 auto;
  color: #e2e8f0;
}

.replay-header {
  margin-bottom: 24px;
}

.replay-header h2 {
  margin: 0 0 6px;
  font-size: 1.25rem;
  color: #f8fafc;
}

.replay-subtitle {
  margin: 0;
  color: #94a3b8;
  font-size: 0.9rem;
}

/* ── Setup panel ── */
.replay-setup {
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 24px;
}

.replay-setup-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.replay-upload-label {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(99, 102, 241, 0.15);
  border: 1px solid rgba(99, 102, 241, 0.35);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.88rem;
  color: #a5b4fc;
  transition: background 0.15s;
  white-space: nowrap;
}

.replay-upload-label:hover {
  background: rgba(99, 102, 241, 0.25);
}

.replay-entry-count {
  font-size: 0.82rem;
  color: #64748b;
}

.replay-field-label {
  font-size: 0.82rem;
  color: #94a3b8;
  white-space: nowrap;
}

.replay-select {
  background: rgba(15, 23, 42, 0.8);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 8px;
  color: #e2e8f0;
  padding: 8px 12px;
  font-size: 0.88rem;
  flex: 1 1;
  min-width: 220px;
}

.replay-generate-btn {
  align-self: flex-start;
  padding: 9px 20px;
  background: rgba(16, 185, 129, 0.15);
  border: 1px solid rgba(16, 185, 129, 0.35);
  border-radius: 8px;
  color: #6ee7b7;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}

.replay-generate-btn:hover:not(:disabled) {
  background: rgba(16, 185, 129, 0.25);
}

.replay-generate-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.replay-error {
  color: #fca5a5;
  font-size: 0.88rem;
  margin: 0;
  padding: 8px 12px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: 6px;
}

/* ── Player ── */
.replay-player {
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid rgba(148, 163, 184, 0.12);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Transport */
.replay-transport {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.transport-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.transport-right {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 0.85rem;
  color: #94a3b8;
}

.transport-time {
  font-variant-numeric: tabular-nums;
}

.transport-walltime {
  font-size: 0.78rem;
  color: #64748b;
}

.transport-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(148, 163, 184, 0.1);
  border: 1px solid rgba(148, 163, 184, 0.18);
  border-radius: 8px;
  color: #e2e8f0;
  cursor: pointer;
  transition: background 0.15s;
}

.transport-btn:hover:not(:disabled) {
  background: rgba(148, 163, 184, 0.2);
}

.transport-play {
  width: 42px;
  height: 42px;
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.3);
  color: #6ee7b7;
}

.transport-play:hover:not(:disabled) {
  background: rgba(16, 185, 129, 0.25);
}

.transport-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.speed-buttons {
  display: flex;
  gap: 4px;
}

.speed-btn {
  padding: 4px 10px;
  background: rgba(148, 163, 184, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.15);
  border-radius: 6px;
  color: #94a3b8;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s, color 0.12s;
}

.speed-btn.active {
  background: rgba(99, 102, 241, 0.2);
  border-color: rgba(99, 102, 241, 0.4);
  color: #a5b4fc;
}

.speed-btn:hover:not(.active) {
  background: rgba(148, 163, 184, 0.15);
  color: #e2e8f0;
}

/* Scrubber */
.replay-scrubber {
  width: 100%;
  accent-color: #6ee7b7;
  cursor: pointer;
}

/* Session bar */
.replay-session-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.session-pills {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.session-pill-badge {
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 0.76rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  background: rgba(148, 163, 184, 0.1);
  color: #64748b;
  border: 1px solid transparent;
}

.session-pill-badge.active {
  background: rgba(16, 185, 129, 0.15);
  color: #6ee7b7;
  border-color: rgba(16, 185, 129, 0.3);
}

.session-pill-badge.ended {
  background: rgba(245, 158, 11, 0.1);
  color: #fbbf24;
}

.session-pill-badge.upcoming {
  opacity: 0.4;
}

.replay-session-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #e2e8f0;
  margin-left: auto;
}

.ended-tag {
  color: #fbbf24;
  font-size: 0.8em;
}

.replay-progress-bar {
  width: 120px;
  height: 4px;
  background: rgba(148, 163, 184, 0.15);
  border-radius: 99px;
  overflow: hidden;
}

.replay-progress-fill {
  height: 100%;
  background: #6ee7b7;
  border-radius: 99px;
  transition: width 0.1s linear;
}

/* Table */
.replay-table-wrap {
  overflow-x: auto;
  border-radius: 8px;
}

.replay-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.88rem;
}

.replay-table th {
  padding: 8px 10px;
  text-align: left;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  font-size: 0.76rem;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);
  white-space: nowrap;
  position: sticky;
  top: 0;
  background: rgba(15, 23, 42, 0.96);
}

.replay-table td {
  padding: 9px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.07);
  color: #e2e8f0;
  white-space: nowrap;
}

.replay-table tbody tr:hover td {
  background: rgba(148, 163, 184, 0.05);
}

.replay-table tbody tr.row-left td {
  opacity: 0.45;
  font-style: italic;
}

.replay-table .col-pos { width: 42px; text-align: center; }
.replay-table .col-car-num { width: 52px; text-align: center; }
.replay-table .col-best,
.replay-table .col-last { width: 90px; font-variant-numeric: tabular-nums; }
.replay-table .col-laps,
.replay-table .col-pits { width: 55px; text-align: center; }
.replay-table .col-status { width: 100px; }
.replay-table .col-ev { width: 60px; }

.left-tag {
  font-size: 0.75em;
  color: #64748b;
  font-style: normal;
}

.collision-badge {
  display: inline-flex;
  align-items: center;
  color: #fbbf24;
}

.replay-empty {
  color: #64748b;
  text-align: center;
  padding: 24px;
  font-size: 0.9rem;
}

.replay-footer {
  font-size: 0.78rem;
  color: #475569;
  text-align: right;
}

/* Light theme */
body.light-theme .log-replay-tool {
  color: #1e293b;
}

body.light-theme .replay-header h2 {
  color: #0f172a;
}

body.light-theme .replay-subtitle,
body.light-theme .replay-field-label {
  color: #64748b;
}

body.light-theme .replay-setup,
body.light-theme .replay-player {
  background: rgba(248, 250, 252, 0.8);
  border-color: rgba(0, 0, 0, 0.1);
}

body.light-theme .replay-select {
  background: #f8fafc;
  border-color: rgba(0, 0, 0, 0.15);
  color: #1e293b;
}

body.light-theme .replay-table th {
  background: rgba(248, 250, 252, 0.96);
  color: #94a3b8;
}

body.light-theme .replay-table td {
  color: #1e293b;
}

body.light-theme .transport-btn {
  color: #1e293b;
}
`, "",{"version":3,"sources":["webpack://./src/components/LogReplayTool.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,MAAM;EACN,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA,yBAAyB,WAAW,EAAE,kBAAkB,EAAE;AAC1D,6BAA6B,WAAW,EAAE,kBAAkB,EAAE;AAC9D;0BAC0B,WAAW,EAAE,kCAAkC,EAAE;AAC3E;0BAC0B,WAAW,EAAE,kBAAkB,EAAE;AAC3D,4BAA4B,YAAY,EAAE;AAC1C,wBAAwB,WAAW,EAAE;;AAErC;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".log-replay-tool {\r\n  padding: 24px;\r\n  max-width: 1100px;\r\n  margin: 0 auto;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.replay-header {\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.replay-header h2 {\r\n  margin: 0 0 6px;\r\n  font-size: 1.25rem;\r\n  color: #f8fafc;\r\n}\r\n\r\n.replay-subtitle {\r\n  margin: 0;\r\n  color: #94a3b8;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* ── Setup panel ── */\r\n.replay-setup {\r\n  background: rgba(15, 23, 42, 0.7);\r\n  border: 1px solid rgba(148, 163, 184, 0.12);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 14px;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.replay-setup-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.replay-upload-label {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 16px;\r\n  background: rgba(99, 102, 241, 0.15);\r\n  border: 1px solid rgba(99, 102, 241, 0.35);\r\n  border-radius: 8px;\r\n  cursor: pointer;\r\n  font-size: 0.88rem;\r\n  color: #a5b4fc;\r\n  transition: background 0.15s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.replay-upload-label:hover {\r\n  background: rgba(99, 102, 241, 0.25);\r\n}\r\n\r\n.replay-entry-count {\r\n  font-size: 0.82rem;\r\n  color: #64748b;\r\n}\r\n\r\n.replay-field-label {\r\n  font-size: 0.82rem;\r\n  color: #94a3b8;\r\n  white-space: nowrap;\r\n}\r\n\r\n.replay-select {\r\n  background: rgba(15, 23, 42, 0.8);\r\n  border: 1px solid rgba(148, 163, 184, 0.2);\r\n  border-radius: 8px;\r\n  color: #e2e8f0;\r\n  padding: 8px 12px;\r\n  font-size: 0.88rem;\r\n  flex: 1;\r\n  min-width: 220px;\r\n}\r\n\r\n.replay-generate-btn {\r\n  align-self: flex-start;\r\n  padding: 9px 20px;\r\n  background: rgba(16, 185, 129, 0.15);\r\n  border: 1px solid rgba(16, 185, 129, 0.35);\r\n  border-radius: 8px;\r\n  color: #6ee7b7;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.replay-generate-btn:hover:not(:disabled) {\r\n  background: rgba(16, 185, 129, 0.25);\r\n}\r\n\r\n.replay-generate-btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.replay-error {\r\n  color: #fca5a5;\r\n  font-size: 0.88rem;\r\n  margin: 0;\r\n  padding: 8px 12px;\r\n  background: rgba(239, 68, 68, 0.1);\r\n  border-radius: 6px;\r\n}\r\n\r\n/* ── Player ── */\r\n.replay-player {\r\n  background: rgba(15, 23, 42, 0.7);\r\n  border: 1px solid rgba(148, 163, 184, 0.12);\r\n  border-radius: 12px;\r\n  padding: 20px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n/* Transport */\r\n.replay-transport {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n}\r\n\r\n.transport-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.transport-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  font-size: 0.85rem;\r\n  color: #94a3b8;\r\n}\r\n\r\n.transport-time {\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.transport-walltime {\r\n  font-size: 0.78rem;\r\n  color: #64748b;\r\n}\r\n\r\n.transport-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  background: rgba(148, 163, 184, 0.1);\r\n  border: 1px solid rgba(148, 163, 184, 0.18);\r\n  border-radius: 8px;\r\n  color: #e2e8f0;\r\n  cursor: pointer;\r\n  transition: background 0.15s;\r\n}\r\n\r\n.transport-btn:hover:not(:disabled) {\r\n  background: rgba(148, 163, 184, 0.2);\r\n}\r\n\r\n.transport-play {\r\n  width: 42px;\r\n  height: 42px;\r\n  background: rgba(16, 185, 129, 0.15);\r\n  border-color: rgba(16, 185, 129, 0.3);\r\n  color: #6ee7b7;\r\n}\r\n\r\n.transport-play:hover:not(:disabled) {\r\n  background: rgba(16, 185, 129, 0.25);\r\n}\r\n\r\n.transport-btn:disabled {\r\n  opacity: 0.35;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.speed-buttons {\r\n  display: flex;\r\n  gap: 4px;\r\n}\r\n\r\n.speed-btn {\r\n  padding: 4px 10px;\r\n  background: rgba(148, 163, 184, 0.08);\r\n  border: 1px solid rgba(148, 163, 184, 0.15);\r\n  border-radius: 6px;\r\n  color: #94a3b8;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background 0.12s, color 0.12s;\r\n}\r\n\r\n.speed-btn.active {\r\n  background: rgba(99, 102, 241, 0.2);\r\n  border-color: rgba(99, 102, 241, 0.4);\r\n  color: #a5b4fc;\r\n}\r\n\r\n.speed-btn:hover:not(.active) {\r\n  background: rgba(148, 163, 184, 0.15);\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* Scrubber */\r\n.replay-scrubber {\r\n  width: 100%;\r\n  accent-color: #6ee7b7;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Session bar */\r\n.replay-session-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.session-pills {\r\n  display: flex;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.session-pill-badge {\r\n  padding: 3px 10px;\r\n  border-radius: 999px;\r\n  font-size: 0.76rem;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  background: rgba(148, 163, 184, 0.1);\r\n  color: #64748b;\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.session-pill-badge.active {\r\n  background: rgba(16, 185, 129, 0.15);\r\n  color: #6ee7b7;\r\n  border-color: rgba(16, 185, 129, 0.3);\r\n}\r\n\r\n.session-pill-badge.ended {\r\n  background: rgba(245, 158, 11, 0.1);\r\n  color: #fbbf24;\r\n}\r\n\r\n.session-pill-badge.upcoming {\r\n  opacity: 0.4;\r\n}\r\n\r\n.replay-session-label {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: #e2e8f0;\r\n  margin-left: auto;\r\n}\r\n\r\n.ended-tag {\r\n  color: #fbbf24;\r\n  font-size: 0.8em;\r\n}\r\n\r\n.replay-progress-bar {\r\n  width: 120px;\r\n  height: 4px;\r\n  background: rgba(148, 163, 184, 0.15);\r\n  border-radius: 99px;\r\n  overflow: hidden;\r\n}\r\n\r\n.replay-progress-fill {\r\n  height: 100%;\r\n  background: #6ee7b7;\r\n  border-radius: 99px;\r\n  transition: width 0.1s linear;\r\n}\r\n\r\n/* Table */\r\n.replay-table-wrap {\r\n  overflow-x: auto;\r\n  border-radius: 8px;\r\n}\r\n\r\n.replay-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 0.88rem;\r\n}\r\n\r\n.replay-table th {\r\n  padding: 8px 10px;\r\n  text-align: left;\r\n  color: #64748b;\r\n  font-weight: 700;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.06em;\r\n  font-size: 0.76rem;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.1);\r\n  white-space: nowrap;\r\n  position: sticky;\r\n  top: 0;\r\n  background: rgba(15, 23, 42, 0.96);\r\n}\r\n\r\n.replay-table td {\r\n  padding: 9px 10px;\r\n  border-bottom: 1px solid rgba(148, 163, 184, 0.07);\r\n  color: #e2e8f0;\r\n  white-space: nowrap;\r\n}\r\n\r\n.replay-table tbody tr:hover td {\r\n  background: rgba(148, 163, 184, 0.05);\r\n}\r\n\r\n.replay-table tbody tr.row-left td {\r\n  opacity: 0.45;\r\n  font-style: italic;\r\n}\r\n\r\n.replay-table .col-pos { width: 42px; text-align: center; }\r\n.replay-table .col-car-num { width: 52px; text-align: center; }\r\n.replay-table .col-best,\r\n.replay-table .col-last { width: 90px; font-variant-numeric: tabular-nums; }\r\n.replay-table .col-laps,\r\n.replay-table .col-pits { width: 55px; text-align: center; }\r\n.replay-table .col-status { width: 100px; }\r\n.replay-table .col-ev { width: 60px; }\r\n\r\n.left-tag {\r\n  font-size: 0.75em;\r\n  color: #64748b;\r\n  font-style: normal;\r\n}\r\n\r\n.collision-badge {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  color: #fbbf24;\r\n}\r\n\r\n.replay-empty {\r\n  color: #64748b;\r\n  text-align: center;\r\n  padding: 24px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.replay-footer {\r\n  font-size: 0.78rem;\r\n  color: #475569;\r\n  text-align: right;\r\n}\r\n\r\n/* Light theme */\r\nbody.light-theme .log-replay-tool {\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .replay-header h2 {\r\n  color: #0f172a;\r\n}\r\n\r\nbody.light-theme .replay-subtitle,\r\nbody.light-theme .replay-field-label {\r\n  color: #64748b;\r\n}\r\n\r\nbody.light-theme .replay-setup,\r\nbody.light-theme .replay-player {\r\n  background: rgba(248, 250, 252, 0.8);\r\n  border-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\nbody.light-theme .replay-select {\r\n  background: #f8fafc;\r\n  border-color: rgba(0, 0, 0, 0.15);\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .replay-table th {\r\n  background: rgba(248, 250, 252, 0.96);\r\n  color: #94a3b8;\r\n}\r\n\r\nbody.light-theme .replay-table td {\r\n  color: #1e293b;\r\n}\r\n\r\nbody.light-theme .transport-btn {\r\n  color: #1e293b;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
